import { BigNumber, utils } from 'ethers'

export function formatBigNumber(value: BigNumber, decimals = 18) {
  if (!value) {
    return '0'
  }
  return cutZeroFromInteger(utils.formatUnits(value, decimals))
}

export function cutZeroFromInteger(value: string) {
  const splitValue = value.split('.')
  return splitValue[1] === '0' ? splitValue[0] : value
}

export function cutPrecision(value: string, precision: number) {
  const splitValue = value.split('.')
  return splitValue[1] ? `${splitValue[0]}.${splitValue[1].slice(0, precision)}` : value
}
